import React, { Component } from 'react';
import { Redirect } from 'react-router'
import { inject, observer } from 'mobx-react';
import { get, post } from 'axios';
import Notifications, {notify} from 'react-notify-toast';
import {Calendar, momentLocalizer} from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css'
import momenttz from 'moment-timezone';
import Bookings from './Bookings';
import ModalAvailability from './ModalAvailability';
import Modal from 'react-bootstrap4-modal';
import DatePicker from "react-datepicker";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import Gravatar from 'react-gravatar';
import PerfectScrollbar from 'react-perfect-scrollbar';
import InputMask from 'react-input-mask';
import PlacesAutocomplete, {
  geocodeByAddress,
  geocodeByPlaceId,
} from 'react-places-autocomplete';


const localizer = momentLocalizer(momenttz);

class InquiryRow extends Component{
  constructor(props){
      super(props);
  }

  render(){
    const {inquiry, type, selectHandler} = this.props;
    return (
      <div className="media cursor-pointer" onClick={() => selectHandler(inquiry)}>
        <span className="avatar">
          <Gravatar email={inquiry.email} size={36} rating="pg" default="identicon"/>
        </span>
        <div className="media-body">
          <p><strong>{inquiry.full_name}</strong> <time className="float-right">{inquiry.age_of}</time></p>
          <p>{inquiry.date} - {inquiry.ready_time}</p>
          {type === 'review' ? <span className="badge badge-warning">Accept/Decline</span> : <span className="badge badge-info">Create Proposal</span>}
        </div>
      </div>
    )
  }
}

class InvoiceRow extends Component{
  constructor(props){
      super(props);
  }
  render(){
    const {invoice, selectHandler} = this.props;
    return (
      <div className="media cursor-pointer" onClick={()=>selectHandler(invoice)}>
        <div className="media-body">
          <p><strong>{invoice.description}</strong> <time className="float-right">{invoice.days_since} days old</time></p>
          <p>{invoice.booking.full_name} - ${invoice.due_amount}</p>
          {invoice.is_published ? <span className="badge badge-warning">Awaiting Payment</span> : <span className="badge badge-danger">Unpublished</span>}
        </div>
      </div>
    )
  }
}

class Booking{
  location_name='';
  address='';
  city='';
  state='';
  zipcode='';
  first_name='';
  last_name='';
  event_date=null;
  ready_time=null;
  email='';
  phone_primary='';
  contract=false;
  notes='';
  bus_book_type_id=0;
}

@inject('userStore')
class Dashboard extends Component {
    constructor(props){
        super(props);
        this.state = {
            events:[],
            height:0,
            redirect:false,
            redirectInquiry:false,
            redirectInvoice:false,
            hashId:null,
            visible:false,
            modalType:'',
            eventDate: new Date(),
            inquiry_list:[],
            invoice_list:[],
            inquiriesLoaded:false,
            invoicesLoaded:false,
            inquiryExpanded:true,
            invoiceExpanded:true,
            booking:new Booking(),
            startDate:null,
            bus_book_type_list:[],
            invoiceCount:0,
            inquiryCount:0
        }
        this.handleChange = this.handleChange.bind(this);
    }


    handleChange(date) {
      this.setState({
        eventDate: date
      });
    }

    componentWillReceiveProps(props){
      if (props.userStore.token !== ""){
        this.fetchEvents();
        this.fetchInquiries();
        this.fetchInvoices();
      }
    }

    componentDidMount(){
        const height = this.divElement.clientHeight;
        this.setState({ height });
        if (this.props.userStore.token !== ""){
          this.fetchEvents();
          this.fetchInquiries();
          this.fetchInvoices();
          this.fetchBooktype();
        }
    }

    getPlace = placeId => {
        var service = new window.google.maps.places.PlacesService(document.createElement('div'));
        return new Promise((resolve, reject) => {
            service.getDetails({'placeId':placeId}, (results, status)=>{
                if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
                  reject(status);
                }
                resolve(results);
            });
        });
    };

    handleBookingChange = e => {
      let tmpBooking = Object.assign({}, this.state.booking);
      if (e.target){
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        tmpBooking[e.target.name] = value;
      } else {
        tmpBooking.location_name = e;
      }
      this.setState({ booking:tmpBooking });
    };

    setStart = date => {
      this.setState({startDate: date}, ()=>{
        let tmpBooking = Object.assign({}, this.state.booking);
        tmpBooking.event_date = moment(this.state.startDate).format('MM/DD/YYYY');
        tmpBooking.ready_time = moment(this.state.startDate).format('hh:mm A');
        this.setState({
          booking:tmpBooking
        })
      });
    }


    handleSelect = address => {
      geocodeByAddress(address)
        .then(results => {
            this.getPlace(results[0].place_id).then(results => {
              let tmpBooking = Object.assign({}, this.state.booking);
              tmpBooking.location_name = results.name;
              for (var i = 0; i < results.address_components.length; i++) {
                var addressType = results.address_components[i].types[0];
                if (addressType == 'street_number'){
                  tmpBooking.address = results.address_components[i].long_name;
                }
                if (addressType == 'route'){
                  tmpBooking.address = tmpBooking.address + ' ' + results.address_components[i].short_name;
                }
                if (addressType == 'locality'){
                  tmpBooking.city = results.address_components[i].long_name;
                }
                if (addressType == 'administrative_area_level_1'){
                  var state = results.address_components[i].short_name
                  tmpBooking.state = state;
                }
                if (addressType == 'postal_code'){
                  tmpBooking.zipcode = results.address_components[i].short_name;
                }
              }
              this.setState({ booking:tmpBooking });
            });
        });
      // .then(latLng => console.log('Success', latLng))
      // .catch(error => console.error('Error', error));
    };

    addBooking = () => {
      post('v2/save/booking_manual', {
        booking: this.state.booking
      }, {
        auth: {username: this.props.userStore.token}
      }).then((res) => {
        if (res.data.errors === 0){
          let tmpBooking = Object.assign({}, this.state.booking);
          tmpBooking.first_name = '';
          tmpBooking.last_name = '';
          tmpBooking.email = '';
          tmpBooking.phone_primary = '';
          tmpBooking.location_name = '';
          tmpBooking.address = '';
          tmpBooking.city = '';
          tmpBooking.zipcode = '';
          tmpBooking.notes = '';
          tmpBooking.contract = false;
          this.setState({
            visible:false,
            booking:tmpBooking
          }, ()=>{
            notify.show(res.data.message, 'success', 4000);
          })
        } else {
          alert(res.data.message);
        }
        console.log(res);
      }).catch((error) => {
          console.log(error);
          return error;
      });
    }

    fetchInquiries = () => {
      post('v2/get/inquiries', {
            business_hash_id: this.props.userStore.business_primary.hash_id
        }, {
            auth: {username: this.props.userStore.token}
        }).then((res) => {
          this.setState({
              inquiry_list:res.data.inquiry_list,
              inquiriesLoaded:true,
              inquiryCount:res.data.inquiry_list.filter(invoice => invoice.sys_status_id === 1 && (invoice.current_stage_id === 2 || invoice.current_stage_id === 3)).length
          });
      }).catch((error) => {
            console.log(error);
            return error;
      });
    }

    fetchInvoices = () => {
      post('v2/get/invoice_list_all', {
          type:'unpaid',
          business_hash_id: this.props.userStore.business_primary.hash_id
        }, {
            auth: {username: this.props.userStore.token}
        }).then((res) => {
          this.setState({
              invoice_list:res.data.invoice_list,
              invoicesLoaded:true,
              invoiceCount:res.data.invoice_list.length
          });
      }).catch((error) => {
            console.log(error);
            return error;
      });
    }

    fetchEvents = () => {
        post('v2/get/events', {}, {
                auth: {username: this.props.userStore.token}
            }).then((res) => {
              if (res.data.errors === 0){
                  res.data.events.forEach(function (event) {
                      event.start = moment(event.start, moment.ISO_8601).toDate();
                      event.end = moment(event.end, moment.ISO_8601).toDate();
                  });
                  this.setState({
                      events:res.data.events
                  })
              } else {
                  notify.show(res.data.message, "error", 1000);
              }
          }).catch((error) => {
            return error;
          });
    }

    fetchBooktype = () => {
        if (this.props.userStore.business_primary.hash_id){
            post('/v2/get/bus_book_type', {business_hash_id:this.props.userStore.business_primary.hash_id},{
                auth: {username: this.props.userStore.token}
            }).then((res) => {
                if (res.data.errors === 0){
                  let tmpBooking = Object.assign({}, this.state.booking);
                  tmpBooking.bus_book_type_id = res.data.bus_book_type_list[0].id;
                  this.setState({bus_book_type_list:res.data.bus_book_type_list, booking:tmpBooking});
                } else {
                    notify.show(res.data.message, "error", 3000);
                }
            }).catch((error) => {
                notify.show(error, "error", 3000);
                console.log(error);
                return error;
            });
        }
    }


    modalBackgroundClicked = () => {
        this.setState({
            visible:!this.state.visible,
            modalType:''
        });
    }

    selectEvent = (event) => {
        this.setState({
            redirect:true,
            hashId:event.hash_id
        })
    }

    selectInquiry = (inquiry) => {
        this.setState({
            redirectInquiry:true,
            hashId:inquiry.hash_id
        })
    }

    selectInvoice = (invoice) => {
        this.setState({
            redirectInvoice:true,
            hashId:invoice.hash_id
        })
    }


  render() {
      if (this.state.redirect && this.state.hashId){
          return (<Redirect
            to={{
              pathname: "/bookings",
              state:{hash_id: this.state.hashId}
            }}
          />);
      }
      if (this.state.redirectInquiry && this.state.hashId){
          return (<Redirect
            to={{
              pathname: "/inquiries",
              state:{hash_id: this.state.hashId}
            }}
          />);
      }
      if (this.state.redirectInvoice && this.state.hashId){
        return (<Redirect
          to={{
            pathname: "/invoices",
            state:{hash_id: this.state.hashId}
          }}
        />);
      }
      // BigCalendar.momentLocalizer(moment); // or globalizeLocalizer
    return (
        <React.Fragment>
        <Modal visible={this.state.visible} onClickBackdrop={this.modalBackgroundClicked} dialogClassName="modal-lg">
          {this.state.modalType === 'check' ?
            <React.Fragment>
              <div className="modal-header">
                  <h4 className="modal-title">Check Availability</h4>
                  <button type="button" className="close" onClick={this.modalBackgroundClicked} aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
              </div>
              <div className="modal-body">
                {this.state.visible ?
                  <ModalAvailability date={this.state.eventDate} handler={this.modalBackgroundClicked} business_id={this.props.userStore.business_primary.id}/>
                  :null
                }
              </div>
              <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => this.modalBackgroundClicked(null)}>
                    Close
                  </button>
              </div>
            </React.Fragment>
          :
            <React.Fragment>
              <div className="modal-header">
                  <h4 className="modal-title">Add a Booking</h4>
                  <button type="button" className="close" onClick={this.modalBackgroundClicked} aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
              </div>
              <div className="modal-body form-type-combine">
                <div className="form-groups-attached">
                    <div className="row">
                        <div className="form-group col-4">
                            <label>Booking Type</label>
                            <select name="bus_book_type_id" className="form-control" value={this.state.booking.bus_book_type_id} onChange={this.handleBookingChange}>
                            {this.state.bus_book_type_list ?
                              this.state.bus_book_type_list.map((bus_book_type, idx)=>
                              <option value={bus_book_type.id} key={idx}>{bus_book_type.name}</option>
                            )
                            : null}
                            </select>
                        </div>
                        <div className="form-group col-4">
                            <label>First Name</label>
                            <input className="form-control" name="first_name" type="text" onChange={this.handleBookingChange} value={this.state.booking.first_name}/>
                        </div>
                        <div className="form-group col-4">
                            <label>Last Name</label>
                            <input className="form-control" name="last_name" type="text" onChange={this.handleBookingChange} value={this.state.booking.last_name}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-6">
                            <label>Email</label>
                            <input className="form-control" name="email" type="text" onChange={this.handleBookingChange} value={this.state.booking.email}/>
                        </div>
                        <div className="form-group col-6">
                            <label>Phone</label>
                            <InputMask className="form-control" mask="(999)-999-9999" maskChar=" " name="phone_primary" value={this.state.booking.phone_primary} onChange={this.handleBookingChange} />
                        </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-12">
                        <label>Event Date/Ready Time</label>
                        <div className="form-control">
                          <DatePicker
                            className="form-control"
                            onChange={this.setStart}
                            selected={this.state.startDate}
                            showTimeSelect
                            timeIntervals={15}
                            dateFormat="MMMM d, yyyy h:mm aa"
                            timeCaption="Time"
                            placeholderText="Event Date"
                            name={"event_date_picker"}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                    <PlacesAutocomplete
                        value={this.state.booking.location_name}
                        onChange={this.handleBookingChange}
                        onSelect={this.handleSelect}
                    >
                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                      <React.Fragment>
                      <div className="form-group col-12">
                          <label>Location</label>
                          <input {...getInputProps({
                                placeholder: 'Get Ready Location (type the location and pick from the list)',
                                className: 'form-control',
                                field: "location_name"
                              })}/>
                      </div>
                      <div className={suggestions.length > 0 ? "autocomplete-dropdown-container" : null}>
                        {loading && <div>Loading...</div>}
                        {suggestions.map(suggestion => {
                          const className = suggestion.active
                            ? 'suggestion-item--active'
                            : 'suggestion-item';
                          // inline style for demonstration purpose
                          const style = suggestion.active
                            ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                            : { backgroundColor: '#ffffff', cursor: 'pointer' };
                          return (
                            <div style={{ borderWidth: 0.5, borderColor: '#d6d7da'}}
                              {...getSuggestionItemProps(suggestion, {
                                className,
                                style,
                              })}
                            >
                              <span>{suggestion.description}</span>
                            </div>
                          );
                        })}
                      </div>
                      </React.Fragment>
                    )}
                    </PlacesAutocomplete>
                    </div>
                    <div className="row">
                        <div className="form-group col-12">
                            <label>Address</label>
                            <input className="form-control" name="address" type="text" onChange={this.handleBookingChange} value={this.state.booking.address}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-6">
                            <label>City</label>
                            <input className="form-control" name="city" type="text" onChange={this.handleBookingChange} value={this.state.booking.city}/>
                        </div>
                        <div className="form-group col-2">
                            <label>State</label>
                            <input className="form-control" name="state" type="text" onChange={this.handleBookingChange} value={this.state.booking.state}/>
                        </div>
                        <div className="form-group col-4">
                            <label>Zipcode</label>
                            <input className="form-control" name="zipcode" type="text" onChange={this.handleBookingChange} value={this.state.booking.zipcode}/>
                        </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-12">
                        <label>Notes</label>
                        <textarea className='form-control' name='notes' onChange={this.handleBookingChange} value={this.state.booking.notes}></textarea>
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-12">
                        <div className="custom-control custom-checkbox">
                          <input type="checkbox" className="custom-control-input" name="contract" id="cc-1" checked={this.state.booking.contract} onChange={this.handleBookingChange}/>
                          <label className="custom-control-label" htmlFor="cc-1">Require Contract Signing?</label>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => this.modalBackgroundClicked(null)}>
                    Close
                  </button>
                  <button type="button" className="btn btn-primary" onClick={this.addBooking}>
                    Submit
                  </button>
              </div>
            </React.Fragment>
          }
        </Modal>
        <Notifications />
        <div className="main-content" ref={ (divElement) => this.divElement = divElement}>
            <div className="row">
                <div className="col-md-12 col-lg-8">
                  <div className="row">
                    <div className="col-12">
                      <div className="card">
                          <div className="card-body">
                            <div className="input-group">
                              <DatePicker className="form-control" selected={this.state.eventDate} onChange={this.handleChange} placeholder="Select Event Date"/>
                              <span className="input-group-append">
                                <button className="btn btn-info" type="button" onClick={() => this.setState({visible:true, modalType:'check'})}><i className="fa fa-calendar-check-o"></i> Check Availability</button>
                              </span>
                              <span className="input-group-prepend">
                                <button className="btn btn-success" type="button" onClick={() => this.setState({visible:true, modalType:'booking'})}><i className="fa fa-calendar-plus-o"></i> Manually Add Booking</button>
                              </span>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="card card-body" style={{height:this.state.height - 150 + "px"}}>
                          <Calendar
                              resizable
                              localizer={localizer}
                              events={this.state.events}
                              onSelectEvent={this.selectEvent}
                              defaultDate={new Date()}/>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 col-lg-4">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="card">
                        <ul className="nav nav-tabs nav-tabs-light-mode nav-justified" role="tablist">
                          <li className="nav-item">
                            <a className="nav-link active" data-toggle="tab" href="#inquiries" role="tab">Inquiries <span className="badge badge-pill badge-info">{this.state.inquiryCount}</span></a>
                          </li>
                          <li className="nav-item">
                            <a className="nav-link" data-toggle="tab" href="#invoices" role="tab">Invoices <span className="badge badge-pill badge-info">{this.state.invoiceCount}</span></a>
                          </li>
                        </ul>
                        <div className="card-body tab-content">
                          <div className="tab-pane fade active show" id="inquiries">
                            <div className="media-list media-list-divided media-list-hover">
                            {this.state.inquiriesLoaded ? this.state.inquiry_list ? this.state.inquiry_list.map((inquiry, inquiry_index) => {
                                if (inquiry.current_stage_id === 2 && inquiry.sys_status_id === 1){
                                  return (<InquiryRow key={inquiry_index} selectHandler={this.selectInquiry} inquiry={inquiry} type={'review'}/>);
                                } else if (inquiry.current_stage_id === 3 && inquiry.sys_status_id === 1) {
                                  return (<InquiryRow key={inquiry_index} selectHandler={this.selectInquiry} inquiry={inquiry} type={'proposal'}/>);
                                }
                            }) : <div className="badge badge-info">No Inquiries to worry about :)</div>
                            : <div className="spinner-ball"></div>}
                            </div>
                          </div>
                          <div className="tab-pane fade" id="invoices">
                            <div className="media-list media-list-divided media-list-hover">
                            {this.state.invoicesLoaded ? this.state.invoice_list ? this.state.invoice_list.map((invoice, invoice_index) => {
                                return (<InvoiceRow key={invoice_index} selectHandler={this.selectInvoice} invoice={invoice}/>);
                            }) : <div className="badge badge-info">No Invoices to worry about :)</div>
                            : <div className="spinner-ball"></div>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
             </div>
        </div>
        </React.Fragment>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/business/Dashboard.js